<app-top-navbar [title]="'profile-form.profile' | translate">
  <a class="top-bar-link"
     [routerLink]="['../../']">
    <i class="icon icon-chevron-left"></i>
  </a>
</app-top-navbar>

<div class="wrapper page-edit-profile">
  <app-loyalty-club-header [customHTML]="false"/>

  <div class="content">
    <app-profile-form [data]="memberData"
                      [formErrors]="formErrors"
                      (save)="onSave($event)"/>
  </div>

  <app-loyalty-club-footer/>
</div>
